module.exports = __webpack_public_path__ + "media/images/logo_paypal-e9ab131598c19b23672e2de10dd2fef5.png";